import Icon from "@ant-design/icons";
import { type FunctionComponent } from "react";

import SVG from "images/PlusCircle.svg?react";

import { type IBTIconProps } from "../BTIcon.types";
import { useBaseIcon } from "../BTIcon.utilities";

export const BTIconPlusCircle: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useBaseIcon(baseProps);

    // eslint-disable-next-line react/forbid-elements
    return <Icon {...props} component={SVG} />;
};
